function changeSwatchQs() {
  $(".selector-wrapper :radio").on("change", function (e) {
    var _self = $(this);
    var productItem = $(this).parents(".product-item");
    var productItemLayout = $(this).parents(".action");
    var get_json = productItem.data("json-product");
    var variantList = get_json.variants;
    var option_color = productItem
      .find(".option-color")
      .data("option-position");
    var optionIdx = _self
      .closest("[data-option-index]")
      .data("option-index");
    var swatches = productItemLayout.find(".swatch-element");
    var thisVal = _self.val();
    var selectedVariant;
    // debugger;
    var productInput = productItemLayout.find("[name=id]");
    var selectedSwatchOpt1 = productItemLayout
      .find(".selector-wrapper-1")
      .find("input:checked")
      .val();
    var selectedSwatchOpt2 = productItemLayout
      .find(".selector-wrapper-2")
      .find("input:checked")
      .val();
    var selectedSwatchOpt3 = productItemLayout
      .find(".selector-wrapper-3")
      .find("input:checked")
      .val();
    swatches.removeClass("soldout");
    swatches.find(":radio").prop("disabled", false);
    switch (optionIdx) {
      case 0:
        var availableVariants = variantList.find(function (variant) {
          if (option_color == 1) {
            return (
              variant.option2 == thisVal &&
              variant.option1 == selectedSwatchOpt2
            );
          } else {
            if (option_color == 2) {
              return (
                variant.option3 == thisVal &&
                variant.option1 == selectedSwatchOpt2
              );
            } else {
              return (
                variant.option1 == thisVal &&
                variant.option2 == selectedSwatchOpt2
              );
            }
          }
        });

        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        } else {
          // variant was sold out, so auto select other available variant
          var altAvailableVariants = variantList.find(function (variant) {
            if (option_color == 1) {
              return variant.option2 == thisVal;
            } else {
              if (option_color == 2) {
                return variant.option3 == thisVal;
              } else {
                return variant.option1 == thisVal;
              }
            }
          });
          selectedVariant = altAvailableVariants;
        }
        break;
      case 1:
        var availableVariants = variantList.find(function (variant) {
          if (option_color == 1) {
            return (
              variant.option2 == selectedSwatchOpt1 &&
              variant.option1 == thisVal &&
              variant.option3 == selectedSwatchOpt3
            );
          } else {
            if (option_color == 2) {
              return (
                variant.option3 == selectedSwatchOpt1 &&
                variant.option1 == thisVal &&
                variant.option2 == selectedSwatchOpt3
              );
            } else {
              return (
                variant.option1 == selectedSwatchOpt1 &&
                variant.option2 == thisVal &&
                variant.option3 == selectedSwatchOpt3
              );
            }
          }
        });
        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        } else {
          var altAvailableVariants = variantList.find(function (variant) {
            if (option_color == 1) {
              return (
                variant.option2 == selectedSwatchOpt1 &&
                variant.option1 == thisVal
              );
            } else {
              if (option_color == 2) {
                return (
                  variant.option3 == selectedSwatchOpt1 &&
                  variant.option1 == thisVal
                );
              } else {
                return (
                  variant.option1 == selectedSwatchOpt1 &&
                  variant.option2 == thisVal
                );
              }
            }
          });
          selectedVariant = altAvailableVariants;
        }
        break;
      case 2:
        var availableVariants = variantList.find(function (variant) {
          if (option_color == 1) {
            return (
              variant.option2 == selectedSwatchOpt1 &&
              variant.option1 == selectedSwatchOpt2 &&
              variant.option3 == thisVal
            );
          } else {
            if (option_color == 2) {
              return (
                variant.option3 == selectedSwatchOpt1 &&
                variant.option1 == selectedSwatchOpt2 &&
                variant.option2 == thisVal
              );
            } else {
              return (
                variant.option1 == selectedSwatchOpt1 &&
                variant.option2 == selectedSwatchOpt2 &&
                variant.option3 == thisVal
              );
            }
          }
        });
        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        }
        break;
    }
    if (selectedVariant == undefined) return;
    productInput.val(selectedVariant.id);
    var value = $(this).val();
    
    if (selectedVariant.compare_at_price > selectedVariant.price) {
      productItem
        .find("[data-compare-price-grid]")
        .html(
          Shopify.formatMoney(
            selectedVariant.compare_at_price,
            window.money_format
          )
        );
    } else {
      productItem.find("[data-compare-price-grid]").html("");
    }
    productItem
      .find("[data-price-grid]")
      .html(
        Shopify.formatMoney(selectedVariant.price, window.money_format)
      );
    $(this)
      .parents(".selector-wrapper")
      .find(".form-label span")
      .text(value);
    checkStatusSwatchQs(productItem, productItemLayout);
  });

  $(
    ".product-card__variant--popup--content select.single-option-selector"
  ).on("change", function () {
    var _self = $(this);
    var productItem = $(this).parents(".product-item");
    var productItemLayout = $(this).parents(".action");
    var get_json = productItem.data("json-product");
    var variantList = get_json.variants;
    var option_color = productItem
      .find(".option-color")
      .data("option-position");
    var optionIdx = _self.data("option");
    var swatches = productItem.find(".swatch-element");
    var thisVal = _self.val();
    var selectedVariant;
    var productInput = productItemLayout.find("[name=id]");
    var selectedSwatchOpt1 = productItemLayout
      .find('[data-option="option1"]')
      .val();
    var selectedSwatchOpt2 = productItemLayout
      .find('[data-option="option2"]')
      .val();
    var selectedSwatchOpt3 = productItemLayout
      .find('[data-option="option3"]')
      .val();
    switch (optionIdx) {
      case "option1":
        var availableVariants = variantList.find(function (variant) {
          return (
            variant.option1 == thisVal &&
            variant.option2 == selectedSwatchOpt2 &&
            variant.available
          );
        });
        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        } else {
          // variant was sold out, so auto select other available variant
          var altAvailableVariants = variantList.find(function (variant) {
            return variant.option1 == thisVal && variant.available;
          });
          selectedVariant = altAvailableVariants;
        }
        break;
      case "option2":
        var availableVariants = variantList.find(function (variant) {
          return (
            variant.option1 == selectedSwatchOpt1 &&
            variant.option2 == thisVal &&
            variant.available
          );
        });
        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        }
        break;
      case "option3":
        var availableVariants = variantList.find(function (variant) {
          return (
            variant.option1 == selectedSwatchOpt1 &&
            variant.option2 == selectedSwatchOpt2 &&
            variant.option3 == thisVal &&
            variant.available
          );
        });
        if (availableVariants != undefined) {
          selectedVariant = availableVariants;
        }
        break;
    }
    if (selectedVariant != undefined) {
      productInput.val(selectedVariant.id);
    }

    var value = $(this).val();
    $(this)
      .parents(".selector-wrapper")
      .find(".form-label span")
      .text(value);

    checkStatusSwatchQs(productItem, productItemLayout);

    // if (selectedVariant.featured_image) {
    //     productItem.find('#product-featured-image').attr('src', selectedVariant.featured_image.src);
    // }
  });
}

function checkStatusSwatchQs(productItem, productItemLayout) {
  if (window.use_color_swatch) {
    var get_json = productItem.data("json-product");
    var variantList = get_json.variants;
    var options = productItem.find("[data-option-index]");
    var option_color = productItem
      .find(".option-color")
      .data("option-position");
    if (productItemLayout == undefined) {
      productItemLayout = productItem;
    }
    var selectedSwatchOpt1 = productItemLayout
      .find('[data-option-index="0"]')
      .find("input:checked")
      .val();
    var selectedSwatchOpt2 = productItemLayout
      .find('[data-option-index="1"]')
      .find("input:checked")
      .val();
    var selectedSwatchOpt3 = productItemLayout
      .find('[data-option-index="2"]')
      .find("input:checked")
      .val();
    options.each(function () {
      var optionIndex = $(this).data("option-index");
      var swatch = $(this).find(".swatch-element");
      switch (optionIndex) {
        case 0:
          // loop through all swatchs in option 1 and filter sold out swatch
          swatch.each(function () {
            var swatchVal = $(this).data("value");
            var opt1Soldout = variantList.find(function (variant) {
             if (option_color == 1) {
                return variant.option2 == swatchVal && variant.available;
              } else {
                if (option_color == 2) {
                  return variant.option3 == swatchVal && variant.available;
                } else {
                  return variant.option1 == swatchVal && variant.available;
                }
              }
            });
            
            var optionUnavailable = variantList.find(function (variant) {
              if (option_color == 1) {
                return variant.option2 == swatchVal;
              } else {
                if (option_color == 2) {
                  return variant.option3 == swatchVal;
                } else {
                  return variant.option1 == swatchVal;
                }
              }
            });
            if (opt1Soldout == undefined) {
              if (optionUnavailable == undefined) {
                $(this).addClass("unavailable");
                $(this).removeClass("soldout");
                $(this).removeClass("available");
                $(this).find(":radio").prop("checked", false);
              } else {
                $(this).addClass("soldout");
                $(this).removeClass("unavailable");
                $(this).removeClass("available");
                $(this).find(":radio").prop("disabled", false);
                productItemLayout
                  .find("[data-btn-addtocart]")
                  .addClass("unavailable")
                  .attr("disable");
              }
            } else {
              $(this).removeClass("soldout");
              $(this).removeClass("unavailable");
              $(this).addClass("available");
              $(this).find(":radio").prop("disabled", false);
              productItemLayout
                .find("[data-btn-addtocart], [data-btn-addtobundle]")
                .removeClass("unavailable")
                .removeAttr("disable");
            }
          });
          break;
        case 1:
          swatch.each(function () {
            var swatchVal = $(this).data("value");
            var opt1Soldout = variantList.find(function (variant) {
              if (option_color == 1) {
                return (
                  variant.option2 == selectedSwatchOpt1 &&
                  variant.option1 == swatchVal &&
                  variant.available
                );
              } else {
                if (option_color == 2) {
                  return (
                    variant.option3 == selectedSwatchOpt1 &&
                    variant.option1 == swatchVal &&
                    variant.available
                  );
                } else {
                  return (
                    variant.option1 == selectedSwatchOpt1 &&
                    variant.option2 == swatchVal &&
                    variant.available
                  );
                }
              }
            });
            var optionUnavailable = variantList.find(function (variant) {
              if (option_color == 1) {
                return (
                  variant.option2 == selectedSwatchOpt1 &&
                  variant.option1 == swatchVal
                );
              } else {
                if (option_color == 2) {
                  return (
                    variant.option3 == selectedSwatchOpt1 &&
                    variant.option1 == swatchVal
                  );
                } else {
                  return (
                    variant.option1 == selectedSwatchOpt1 &&
                    variant.option2 == swatchVal
                  );
                }
              }
            });
            
            if (opt1Soldout == undefined) {
              if (optionUnavailable == undefined) {
                $(this).addClass("unavailable");
                $(this).removeClass("soldout");
                $(this).removeClass("available");
                $(this).find(":radio").prop("checked", false);
              } else {
                $(this).addClass("soldout");
                $(this).removeClass("unavailable");
                $(this).removeClass("available");
                $(this).find(":radio").prop("disabled", false);
                // $(this).find(':radio').prop('checked',true);
                productItemLayout
                  .find("[data-btn-addtocart], [data-btn-addtobundle]")
                  .addClass("unavailable")
                  .attr("disable");
              }
            } else {
              $(this).removeClass("soldout");
              $(this).removeClass("unavailable");
              $(this).addClass("available");
              $(this).find(":radio").prop("disabled", false);
              productItemLayout
                .find("[data-btn-addtocart], [data-btn-addtobundle]")
                .removeClass("unavailable")
                .removeAttr("disable");
            }
          });
          break;
        case 2:
          // loop through all swatchs in option 3 anh filter sold out swatch
          swatch.each(function () {
            var swatchVal = $(this).data("value");
            var opt1Soldout = variantList.find(function (variant) {
              if (option_color == 1) {
                return (
                  variant.option2 == selectedSwatchOpt1 &&
                  variant.option1 == selectedSwatchOpt2 &&
                  variant.option3 == swatchVal &&
                  variant.available
                );
              } else {
                if (option_color == 2) {
                  return (
                    variant.option3 == selectedSwatchOpt1 &&
                    variant.option1 == selectedSwatchOpt2 &&
                    variant.option2 == swatchVal &&
                    variant.available
                  );
                } else {
                  return (
                    variant.option1 == selectedSwatchOpt1 &&
                    variant.option2 == selectedSwatchOpt2 &&
                    variant.option3 == swatchVal &&
                    variant.available
                  );
                }
              }
            });
            var optionUnavailable = variantList.find(function (variant) {
              if (option_color == 1) {
                return (
                  variant.option2 == selectedSwatchOpt1 &&
                  variant.option1 == selectedSwatchOpt2 &&
                  variant.option3 == swatchVal
                );
              } else {
                if (option_color == 2) {
                  return (
                    variant.option3 == selectedSwatchOpt1 &&
                    variant.option1 == selectedSwatchOpt2 &&
                    variant.option2 == swatchVal
                  );
                } else {
                  return (
                    variant.option1 == selectedSwatchOpt1 &&
                    variant.option2 == selectedSwatchOpt2 &&
                    variant.option3 == swatchVal
                  );
                }
              }
            });
            if (opt1Soldout == undefined) {
              if (optionUnavailable == undefined) {
                $(this).addClass("unavailable");
                $(this).removeClass("soldout");
                $(this).removeClass("available");
                $(this).find(":radio").prop("checked", false);
              } else {
                $(this).addClass("soldout");
                $(this).removeClass("unavailable");
                $(this).removeClass("available");
                $(this).find(":radio").prop("disabled", false);
                // $(this).find(':radio').prop('checked',true);
                productItemLayout
                  .find("[data-btn-addtocart], [data-btn-addtobundle]")
                  .addClass("unavailable")
                  .attr("disable");
              }
            } else {
              $(this).removeClass("soldout");
              $(this).removeClass("unavailable");
              $(this).addClass("available");
              $(this).find(":radio").prop("disabled", false);
              productItemLayout
                .find("[data-btn-addtocart]")
                .removeClass("unavailable")
                .removeAttr("disable");
            }
          });
          break;
      }
    });
    
    if (
      productItemLayout
        .find(".swatch-element.soldout")
        .find("input:checked").length
    ) {
      productItemLayout
        .find("[data-btn-addtocart], [data-btn-addtobundle]")
        .addClass("disabled")
        .attr("disabled", true);
    } else {
      productItemLayout
        .find("[data-btn-addtocart], [data-btn-addtobundle]")
        .removeClass("disabled")
        .removeAttr("disabled");
    }
    productItemLayout
      .find(".selector-wrapper:not(.option-color)")
      .each(function () {
        if (
          $(this).find(".swatch-element").find("input:checked").length < 1
        ) {
          if ($(this).find(".swatch-element.available").length) {
            $(this)
              .find(".swatch-element.available")
              .eq("0")
              .find("label")
              .trigger("click");
          } else {
            $(this)
              .find(".swatch-element.soldout")
              .eq("0")
              .find("label")
              .trigger("click");
          }
        }
      });
  } else {
    var get_json = productItem.data("json-product");
    var variantList = get_json.variants;
    var options = productItem.find(
      ".product-card__variant--popup--content [data-option]"
    );
    var option_color = productItem
      .find(".option-color")
      .data("option-position");
    var selectedSwatchOpt1 = productItemLayout
      .find(
        '.product-card__variant--popup--content [data-option="option1"]'
      )
      .val();
    var selectedSwatchOpt2 = productItemLayout
      .find(
        '.product-card__variant--popup--content [data-option="option2"]'
      )
      .val();
    var selectedSwatchOpt3 = productItemLayout
      .find(
        '.product-card__variant--popup--content [data-option="option3"]'
      )
      .val();

    options.each(function () {
      var optionIndex = $(this).data("option-index");
      var swatch = $(this).find("option");
      switch (optionIndex) {
        case 0:
          // loop through all swatchs in option 1 anh filter sold out swatch
          swatch.each(function () {
            var swatchVal = $(this).val();
            var opt1Soldout = variantList.find(function (variant) {
              // if (option_color == 1) {
              //     return variant.option2 == swatchVal && variant.available;
              // } else {
              return variant.option1 == swatchVal && variant.available;
              // }
            });
            if (opt1Soldout == undefined) {
              var optionUnavailable = variantList.find(function (variant) {
                return variant.option1 == swatchVal;
              });
              if (optionUnavailable == undefined) {
                $(this).addClass("unavailable");
                $(this).removeClass("soldOut");
                $(this).attr("disabled", "disabled");
              } else {
                $(this).addClass("soldOut");
                $(this).removeClass("unavailable");
                $(this).removeAttr("disabled", "disabled");
              }
            } else {
              $(this).removeAttr("disabled", "disabled");
              $(this).removeClass("soldOut");
              $(this).removeClass("unavailable");
            }
          });
          break;
        case 1:
          // loop through all swatchs in option 2 anh filter sold out swatch
          swatch.each(function () {
            var swatchVal = $(this).val();
            var opt1Soldout = variantList.find(function (variant) {
              return (
                variant.option1 == selectedSwatchOpt1 &&
                variant.option2 == swatchVal &&
                variant.available
              );
            });
            if (opt1Soldout == undefined) {
              var optionUnavailable = variantList.find(function (variant) {
                return (
                  variant.option1 == selectedSwatchOpt1 &&
                  variant.option2 == swatchVal
                );
              });
              if (optionUnavailable == undefined) {
                $(this).addClass("unavailable");
                $(this).removeClass("soldOut");
                $(this).attr("disabled", "disabled");
              } else {
                $(this).addClass("soldOut");
                $(this).removeClass("unavailable");
                $(this).removeAttr("disabled", "disabled");
              }
            } else {
              $(this).removeAttr("disabled", "disabled");
              $(this).removeClass("soldOut");
              $(this).removeClass("unavailable");
            }
          });
          break;
        case 2:
          // loop through all swatchs in option 3 anh filter sold out swatch
          swatch.each(function () {
            var swatchVal = $(this).val();
            var opt1Soldout = variantList.find(function (variant) {
              return (
                variant.option1 == selectedSwatchOpt1 &&
                variant.option2 == selectedSwatchOpt2 &&
                variant.option3 == swatchVal &&
                variant.available
              );
            });
            if (opt1Soldout == undefined) {
              var optionUnavailable = variantList.find(function (variant) {
                return (
                  variant.option1 == selectedSwatchOpt1 &&
                  variant.option2 == selectedSwatchOpt2 &&
                  variant.option3 == swatchVal
                );
              });
              if (optionUnavailable == undefined) {
                $(this).addClass("unavailable");
                $(this).removeClass("soldOut");
                $(this).attr("disabled", "disabled");
              } else {
                $(this).addClass("soldOut");
                $(this).removeClass("unavailable");
                $(this).removeAttr("disabled", "disabled");
              }
            } else {
              $(this).removeAttr("disabled", "disabled");
              $(this).removeClass("soldOut");
              $(this).removeClass("unavailable");
            }
          });
          break;
      }
    });
    if (
      productItemLayout
        .find(
          ".product-card__variant--popup--content .single-option-selector"
        )
        .find("option.soldOut:selected").length
    ) {
      productItemLayout
        .find("[data-btn-addtocart]")
        .addClass("disabled")
        .attr("disabled", true);
    } else {
      productItemLayout
        .find("[data-btn-addtocart]")
        .removeClass("disabled")
        .removeAttr("disabled");
    }
  }
}

function activeVariantSelected() {
  var blockSticky = $("[data-sticky-add-to-cart]"),
        sltVariantActive = blockSticky.find(".pr-active"),
        variantElm = blockSticky.find(".pr-swatch");
  var optionSelected = $("#product-selectors option:selected"),
    value = optionSelected.val(),
    stickyActive = blockSticky.find(
      '.pr-swatch[data-value="' + value + '"]'
    ),
    stickyText = stickyActive.html();

  sltVariantActive.html(stickyText);
  stickyActive.addClass("active");

  var str = stickyActive.data("img");

  $(".pr-img img").attr({ src: str });

  $(".swatch .swatch-element").each(function (e) {
    var idVariant = $(this).find("input:radio").attr("id");

    $('.swatch input.text[data-value="' + idVariant + '"]').appendTo(
      $(this)
    );
  });

  $(".selector-wrapper").change(function () {
    var n = $("#product-selectors").val();

    $(".sticky_form .pr-selectors li").each(function (e) {
      var t = $(this).find("a").data("value");

      if (t == n) {
        $(this).find("a").addClass("active");
      } else {
        $(this).find("a").removeClass("active");
      }
    });

    $("#product-selectors")
      .change(function () {
        var str = "";

        $("#product-selectors option:selected").each(function () {
          str += $(this).data("imge");
        });

        $(".pr-img img").attr({ src: str });
      })
      .trigger("change");

    if (variantElm.hasClass("active")) {
      var h = $(".sticky_form .pr-swatch.active").html();

      $(".sticky_form .action input[type=hidden]").val(n);
      sltVariantActive.html(h);
      sltVariantActive.attr("data-value", n);
    }
  });
};



$(document).ready(() => {

  $("#product-customization-dropdown").click(function() {
    $("#product-customization").slideToggle();
    $("#product-customization-dropdown i").toggleClass("fa-chevron-down");
    $("#product-customization-dropdown i").toggleClass("fa-chevron-up");
  });
  
  activeVariantSelected();
  var offSetTop = $("#add-to-cart-form .groups-btn").offset().top;
 
  $(window).scroll(function () {
    let scrollTop = $(this).scrollTop();

    if (scrollTop > offSetTop) {
      $("body").addClass("show_sticky");
    } else {
      $("body").removeClass("show_sticky");
    }
  }).trigger("scroll");

  $("#compare-item").click(function(e) {
    if (thisProductInfo == null)
      return;
    let ItemsToCompare = localStorage.getItem("ItemsToCompare") || "{}";
    try {
      ItemsToCompare = JSON.parse(ItemsToCompare);
    } catch (err) {
      ItemsToCompare = {};
    }

    // mdata fix
    if (Object.keys(ItemsToCompare).length > 0  && ItemsToCompare[Object.keys(ItemsToCompare)[0]].hasOwnProperty("mdata") == false)
    {
      localStorage.setItem("ItemsToCompare",'{}')
      ItemsToCompare = {};
    }

    let productName = thisProductInfo.title;
    
    if ($("#compare-item").is(":checked"))
    {
      ItemsToCompare[thisProductInfo.handle] = thisProductInfo;
    }
    else
    {
      delete ItemsToCompare[thisProductInfo.handle];
    }
    
    localStorage.setItem("ItemsToCompare", JSON.stringify(ItemsToCompare));
    
    $(".comparebuttonamount").text(Object.keys(ItemsToCompare).length);

    if (Object.keys(ItemsToCompare).length > 1) {
      $("#comparebutton").addClass("fa-bounce");
    } else {
      $("#comparebutton").removeClass("fa-bounce");
    }
  });

  if (typeof thisProductInfo !== 'undefined')
  {
    let productName = thisProductInfo.title;
    
    let ItemsToCompare = localStorage.getItem("ItemsToCompare") || "{}";
    try {
        ItemsToCompare = JSON.parse(ItemsToCompare);
    } catch (error) {
      ItemsToCompare = {};
    }
  
    
    if (ItemsToCompare.hasOwnProperty(thisProductInfo.handle))
    {
      $("#compare-item").prop("checked",true);
      $("#compare-item").attr("checked",true);
    }
  
    $(".comparebuttonamount").text(Object.keys(ItemsToCompare).length);
    if (Object.keys(ItemsToCompare).length > 1) {
        $("#comparebutton").addClass("fa-bounce");
      } else {
        $("#comparebutton").removeClass("fa-bounce");
      }
    
    $("#compare-button-container").show();
  }
});

$(document).ready(() => {
  let productMoreview = $("[data-more-view-product] .product-img-box");
  let sliderFor = productMoreview.find(".slider-for"),
  sliderNav = productMoreview.find(".slider-nav"),
  vertical = sliderNav.data("vertical");
  
  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command) {
  	if (player == null || command == null) return;
  	player.contentWindow.postMessage(JSON.stringify(command), "*");
  }
  
  sliderFor.on("afterChange", function (event, slick) {
  if (sliderFor.find(".slick-current").find("iframe").length) {
    var player = sliderFor.find("iframe").get(0);
    postMessageToPlayer(player, {
  	event: "command",
  	func: "playVideo",
    });
  
    // player.pause();
  }
  if (sliderFor.find(".slick-current").find("video").length) {
    var video = sliderFor.find(".slick-current").find("video").get(0);
    video.play();
  }
  });

  
  
  sliderFor.on("beforeChange", function (event, slick) {
  if (sliderFor.find(".slick-current").find("iframe").length) {
    var player = sliderFor.find("iframe").get(0);
    postMessageToPlayer(player, {
  	event: "command",
  	func: "pauseVideo",
    });
  
    // player.pause();
  }
  if (sliderFor.find(".slick-current").find("video").length) {
    var video = sliderFor.find(".slick-current").find("video").get(0);
    video.pause();
  }
  });
  
    
  let BigSlider = new Swiper(".slider-for", {
    speed: 1000,
    spaceBetween: 100,
    slidesPerView: 1,
    slidesPerGroup: 1,
    grabCursor: true,
    parallax: true,
    effect: "coverflow",
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    
  });
  let SmallSlider = new Swiper(".slider-nav", {
    speed: 1000,
    slidesPerView: 4,
    addSlidesAfter: 4,
    slideToClickedSlide: true,
    centerslides: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.slider-nav .swiper-button-next',
      prevEl: '.slider-nav .swiper-button-prev',
    },
    thumbs: {
      swiper: BigSlider,
    },
    on: {
      afterInit: (swiper) => {
        swiper.thumbs.swiper.params.slideToClickedSlide = true;
        swiper.thumbs.swiper.update();
      },
      realIndexChange: (swiper) => {
        swiper.thumbs.swiper.slideToLoop(swiper.realIndex);
      },
    },
  });


  
   SmallSlider.on("click", () => {
     //BigSlider.slideTo(SmallSlider.activeIndex);
   });

  
  setTimeout(function () {
      
    $(".product-photo-container a.fancybox").magnificPopup({
          type: 'image',
          
          gallery: {
              enabled: true,
          }
      });//.magnificPopup('open');

  }, 0);

  // title number
  let titleIndex=0;
  if ($(".component-title:visible").length > 1)
  {
    $(".component-title:visible").each(function(){
        titleIndex++;
        $(this).prepend("<div class='title-number'>"+titleIndex+"</div>");
    });
  }
});